
import { useNavigate } from 'react-router-dom';
import MeverHero from './components/MeverHero';
import MeverBrandStory from './components/MeverBrandStory';
import MeverFeatures from './components/MeverFeatures';
import MeverProductGrid from './components/MeverProductGrid';
import SharedNavigation from '../../components/feature/SharedNavigation';
import SharedFooter from '../../components/feature/SharedFooter';

export default function MeverPage() {
  const navigate = useNavigate();

  return (
    <div className="relative">
      <SharedNavigation subLabel="MeVER" />
      <MeverHero />
      <MeverBrandStory />
      <MeverFeatures />
      <MeverProductGrid />

      {/* CTA Section */}
      <section className="py-24 lg:py-32 px-8 lg:px-32 bg-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl font-medium text-gray-900 mb-4">
            お問い合わせ
          </h2>
          <p className="text-base text-gray-500 mb-4">
            製品の詳細、法人向けのお見積もり、カスタマイズのご相談など、お気軽にお問い合わせください。
          </p>
          <p className="text-sm text-gray-400 mb-10">
            For product details, corporate quotes, or customization inquiries, please contact us.
          </p>
          <button
            onClick={() => {
              navigate('/');
              setTimeout(() => {
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 300);
            }}
            className="inline-flex items-center gap-2 px-10 h-14 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            お問い合わせフォームへ / Contact Form
          </button>
        </div>
      </section>

      <SharedFooter />
    </div>
  );
}
